var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockchain02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blockchain--02_00000029045174185761127520000016906451120491908282_",
    d: "M16,31.36C7.53,31.36,0.64,24.47,0.64,16 S7.53,0.64,16,0.64S31.36,7.53,31.36,16S24.47,31.36,16,31.36z M16,1.36C7.927,1.36,1.36,7.927,1.36,16 c0,8.072,6.567,14.64,14.64,14.64c8.072,0,14.64-6.567,14.64-14.64S24.072,1.36,16,1.36z M16.36,29h-0.72v-5h0.72V29z M22,23.36h-5 v-0.72h5V23.36z M15,23.36h-5v-0.72h5V23.36z M16.36,22h-0.72v-5h0.72V22z M9.36,22H8.64v-5h0.72C9.36,17,9.36,22,9.36,22z  M29,16.36h-5v-0.72h5V16.36z M22,16.36h-5v-0.72h5V16.36z M8,16.36H3v-0.72h5V16.36z M23.36,15h-0.72v-5h0.721L23.36,15L23.36,15z  M16.36,15h-0.72v-5h0.72V15z M22,9.36h-5V8.64h5V9.36z M15,9.36h-5V8.64h5V9.36z M16.36,8h-0.72V3h0.72V8z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain02);
export default __webpack_public_path__ + "../static/product-explorer/assets/blockchain--02.4501d9dd06bb9ff5a1b764b284b27d89.svg";
export { ForwardRef as ReactComponent };